import type { Group } from '../../types';
import type { StateCountry } from '@td/dictionaries';

export function filterStates(search: string, states: Array<StateCountry>): Array<Group<StateCountry>> {
  const filtered = search
    ? states.filter((state) => state.stateName.toLowerCase().startsWith(search.toLowerCase()))
    : states;
  return filtered.reduce(
    (prev, current) => {
      const group = prev.find((g) => g.name === current.countryCode);
      if (!group) {
        return [
          ...prev,
          {
            name: current.countryCode === 'OTHER' ? '' : current.countryCode,
            items: [current],
          },
        ];
      }
      group.items.push(current);
      return prev;
    },
    [] as Array<Group<StateCountry>>,
  );
}
